import { createStyleSet } from 'botframework-webchat';
import { ENGLISH } from './supportedLanguages';
// import botAvatar from '../assets/images/avatar.png';
import userAvatar from '../assets/images/astro.svg';
import dots from '../assets/images/dots.gif';

export const getWebChatStyleSet = (webChatConfiguration = {}, language = ENGLISH) => {
	const styleSet = createStyleSet({
		...webChatConfiguration,
		accent: webChatConfiguration.accent ? webChatConfiguration.accent : 'white',
		backgroundColor: webChatConfiguration.backgroundColor ? webChatConfiguration.backgroundColor : 'Transparent',
	//	botAvatarImage: webChatConfiguration.botAvatarImage ? webChatConfiguration.botAvatarImage : botAvatar,
		userAvatarImage: webChatConfiguration.userAvatar ? webChatConfiguration.userAvatar : userAvatar,
		// botAvatarInitials: webChatConfiguration.botAvatarInitials ? webChatConfiguration.botAvatarInitials : 'Blackstone Bot',
		userAvatarInitials: webChatConfiguration.userAvatarInitials ? webChatConfiguration.userAvatarInitials : 'You',
		avatarSize: webChatConfiguration.avatarSize ? webChatConfiguration.avatarSize : 30,
		bubbleBackground: webChatConfiguration.bubbleBackground ? webChatConfiguration.bubbleBackground : '#F2F2F2',
		bubbleMinHeight: 20,
		bubbleLineHeight:'52px',
		bubbleBorderRadius: webChatConfiguration.bubbleBorderRadius ? webChatConfiguration.bubbleBorderRadius : 8,
		bubbleFromUserBackground: webChatConfiguration.bubbleFromUserBackground ? webChatConfiguration.bubbleFromUserBackground : '#0064bd',
		bubbleFromUserBorderRadius: webChatConfiguration.bubbleFromUserBorderRadius ? webChatConfiguration.bubbleFromUserBorderRadius : 8,
		bubbleFromUserTextColor: webChatConfiguration.bubbleFromUserTextColor ? webChatConfiguration.bubbleFromUserTextColor : '#ffff',
		bubbleTextColor: webChatConfiguration.bubbleTextColor ? webChatConfiguration.bubbleTextColor : '#000000',
		bubbleImageHeight: webChatConfiguration.bubbleImageHeight ? webChatConfiguration.bubbleImageHeight : 240,
		sendBoxBackground: webChatConfiguration.sendBoxBackground ? webChatConfiguration.sendBoxBackground : '#f7f7f9',
		sendBoxButtonColor: webChatConfiguration.sendBoxButtonColor ? webChatConfiguration.sendBoxButtonColor : '#767676',
		sendBoxHeight: webChatConfiguration.sendBoxHeight ? webChatConfiguration.sendBoxHeight : 65,
		sendBoxMaxHeight: webChatConfiguration.sendBoxMaxHeight ? webChatConfiguration.sendBoxMaxHeight : 200,
		bubbleMaxWidth: webChatConfiguration.bubbleMaxWidth ? webChatConfiguration.bubbleMaxWidth : '88%',
		bubbleMinWidth: webChatConfiguration.bubbleMinWidth ? webChatConfiguration.bubbleMinWidth : 250,
		typingAnimationHeight: webChatConfiguration.typingAnimationHeight ? webChatConfiguration.typingAnimationHeight : 50,
		typingAnimationWidth: webChatConfiguration.typingAnimationWidth ? webChatConfiguration.typingAnimationWidth : 50,
		typingAnimationBackgroundImage: webChatConfiguration.typingAnimationBackgroundImage ? webChatConfiguration.typingAnimationBackgroundImage : `url(${dots})`
	});

	styleSet.root = Object.assign(
		{},
		styleSet.root,
		{
			/* width */
			' ::-webkit-scrollbar': {
				// 'width': '6px',
				'backgroundcolor': '#F5F5F5',
				'width': '5px'
			},

			/* Track */
			' ::-webkit-scrollbar-track': {
				'WebkitBoxShadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
				'borderradius': '10px',
				'backgroundcolor': '#F5F5F5'
			},

			/* Handle */
			' ::-webkit-scrollbar-thumb': {
				'borderradius': '10px',
				'WebkitBoxShadow': 'inset 0 0 6px rgba(0,0,0,.3)',
				'backgroundcolor': '#555'
			},

			/* Handle on hover */
			' ::-webkit-scrollbar-thumb:hover': {
				'backgroundcolor': '#777'
			},

			/* width */
			'-moz-scrollbar': {
				// 'width': '6px',
				'backgroundcolor': '#F5F5F5',
				'width': '5px'
			},

			/* Track */
			'-moz-scrollbar-track': {
				'WebkitBoxShadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
				'borderradius': '10px',
				'backgroundcolor': '#F5F5F5'
			},

			/* Handle */
			'-moz-scrollbar-thumb': {
				'borderradius': '10px',
				'WebkitBoxShadow': 'inset 0 0 6px rgba(0,0,0,.3)',
				'backgroundcolor': '#555'
			},

			/* Handle on hover */
			'-moz-scrollbar-thumb:hover': {
				'backgroundcolor': '#777'
			}
		}
	);

	styleSet.sendBox = {
		...styleSet.sendBox,
		'& button:nth-child(odd)': {
			paddingRight: language === ENGLISH ? '5px' : '5px',
			paddingLeft: language === ENGLISH ? '5px' : '5px'
		},
		'& button:nth-child(even)': {
			paddingLeft: language === ENGLISH ? '5px' : '5px',
			paddingRight: language === ENGLISH ? '5px' : '5px'
		},
		'& .ac-inlineActionButton .ac-input .ac-quickActionButton': {
			border: '1px solid #dcdcdc',
			borderRadius: '1px',
			padding: '6px'
		},
		'& button:not(:disabled)': {
			borderRadius: webChatConfiguration && webChatConfiguration.adaptiveCardButtons && webChatConfiguration.adaptiveCardButtons.borderRadius,
		},
		'& button': {
			borderColor: webChatConfiguration && webChatConfiguration.adaptiveCardButtons && webChatConfiguration.adaptiveCardButtons.borderColor, // '#840084', //!important
			borderStyle: webChatConfiguration && webChatConfiguration.adaptiveCardButtons && webChatConfiguration.adaptiveCardButtons.borderStyle, //'solid',
			// fontFamily: webChatConfiguration && webChatConfiguration.adaptiveCardButtons && webChatConfiguration.adaptiveCardButtons.fontFamily //"Calibri" 
		},
		'& button nobr': {
			color: webChatConfiguration && webChatConfiguration.adaptiveCardButtonsNobr && webChatConfiguration.adaptiveCardButtonsNobr.color, // '#840084',
			paddingRight: webChatConfiguration && webChatConfiguration.adaptiveCardButtonsNobr && webChatConfiguration.adaptiveCardButtonsNobr.paddingRight, //'12px'
			paddingLeft: webChatConfiguration && webChatConfiguration.adaptiveCardButtonsNobr && webChatConfiguration.adaptiveCardButtonsNobr.paddingLeft //'12px'
		}
	}

	return styleSet;
}